import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  CheckCircle,
  Lock,
  Sparkles,
  Video,
  Users,
  ArrowRight,
  RefreshCw,
  MessageSquare,
  FileText,
  Check,
  Lightbulb,
  ChevronRight,
  ArrowLeft,
} from "lucide-react";

// const businessStages = [
//   {
//     id: "running",
//     title: "Running a Business",
//     description: "I have a business and want to grow",
//     icon: <CheckCircle className="w-6 h-6" />,
//     tasks: [
//       {
//         id: "tiktok",
//         title: "Auto-Create TikToks & Reels",
//         description:
//           "Directly impacts traffic, brand awareness, and potentially leads through content marketing. Essential for modern growth.",
//         path: "/video",
//         icon: <Video className="w-5 h-5" />,
//         isPro: false,
//         priority: 1,
//       },
//       {
//         id: "ideation",
//         title: "Tweak Product Idea or Find Your Next Feature",
//         description: "Tap into realtime social media conversations to find gaps in current market",
//         path: "/ideate",
//         icon: <Sparkles className="w-5 h-5" />,
//         isPro: false,
//         priority: 2,
//       },
//       {
//         id: "business-plan",
//         title: "Get Clarity on Your Business Idea",
//         description: "Get comprehensive 100+ page report",
//         path: "/report",
//         icon: <FileText className="w-5 h-5" />,
//         isPro: false,
//         priority: 3,
//       },
//       {
//         id: "leads",
//         title: "Find Qualified Leads",
//         description: "Discover and track potential customers",
//         path: "/leadfinder",
//         icon: <Users className="w-5 h-5" />,
//         isPro: false,
//         priority: 4,
//       },
//     ],
//   },
//   {
//     id: "validating",
//     title: "Actively Validating",
//     description: "I have an idea and want to validate it",
//     icon: <Lightbulb className="w-6 h-6" />,
//     tasks: [
//       {
//         id: "business-plan",
//         title: "Validate Idea",
//         description: "Get Clarity with a 100+ page comprehensive report",
//         path: "/report",
//         icon: <FileText className="w-5 h-5" />,
//         isPro: false,
//         priority: 1,
//       },
//       {
//         id: "tiktok",
//         title: "Drive Traffic & Product Awareness",
//         description: "Tweak Headline and Hook Footage to create unlimited Tiktoks",
//         path: "/video",
//         icon: <Video className="w-5 h-5" />,
//         isPro: false,
//         priority: 2,
//       },
//       {
//         id: "ideation",
//         title: "Refine/Tweak Your Idea",
//         description: "Discover gaps and opportunities based on realtime social media conversations",
//         path: "/ideate",
//         icon: <Sparkles className="w-5 h-5" />,
//         isPro: false,
//         priority: 3,
//       },
//       {
//         id: "leads",
//         title: "Find Early Users",
//         description: "Discover potential early adopters",
//         path: "/leadfinder",
//         icon: <Users className="w-5 h-5" />,
//         isPro: false,
//         priority: 4,
//       },
//     ],
//   },
// ];

const businessStages = [
  {
    id: "running",
    title: "🚀 I’m Running a Business",
    description: "I have a product and want to grow it faster.",
    icon: <CheckCircle className="w-6 h-6" />,
    tasks: [
      {
        id: "tiktok",
        title: "🎥 Automate TikTok & Reels Marketing",
        description: "Push unlimited Hook + Demo Videos that drive traffic.",
        path: "/video",
        icon: <Video className="w-5 h-5" />,
        isPro: false,
        priority: 1,
      },
      {
        id: "ideation",
        title: "🧠 Discover What Customers Actually Want",
        description: "Tap into realtime social media conversations to find gaps in current market.",
        path: "/ideate",
        icon: <Sparkles className="w-5 h-5" />,
        isPro: false,
        priority: 2,
      },
      {
        id: "business-plan",
        title: "📊 Validate with 100+ Page Report",
        description: "See market size, competitors, JTBD, pricing and more.",
        path: "/report",
        icon: <FileText className="w-5 h-5" />,
        isPro: false,
        priority: 3,
      },
      // {
      //   id: "leads",
      //   title: "Find Qualified Leads",
      //   description: "Discover and track potential customers",
      //   path: "/leadfinder",
      //   icon: <Users className="w-5 h-5" />,
      //   isPro: false,
      //   priority: 4,
      // },
    ],
  },
  {
    id: "validating",
    title: "📈 I’m Actively Validating an Idea",
    description: "I have an idea and want to test and validate it.",
    icon: <Lightbulb className="w-6 h-6" />,
    tasks: [
      {
        id: "business-plan",
        title: "📊 Validate with 100+ Page Report",
        description: "See market size, competitors, JTBD, pricing and more.",
        path: "/report",
        icon: <FileText className="w-5 h-5" />,
        isPro: false,
        priority: 1,
      },
      {
        id: "tiktok",
        title: "🎥 Launch with Viral TikToks & Reels",
        description: "Push unlimited Hook + Demo Videos that drive traffic.",
        path: "/video",
        icon: <Video className="w-5 h-5" />,
        isPro: false,
        priority: 2,
      },

      {
        id: "ideation",
        title: "🧠 Discover Better Startup Ideas",
        description: "Tap into realtime social media conversations to find gaps in current market.",
        path: "/ideate",
        icon: <FileText className="w-5 h-5" />,
        isPro: false,
        priority: 3,
      },

      // {
      //   id: "feedback",
      //   title: "🗣️ Interview 50+ AI Personas Instantly",
      //   description: "Test features and messaging with hyper-realistic personas — zero scheduling, real insights.",
      //   path: "/feedback",
      //   icon: <FileText className="w-5 h-5" />,
      //   isPro: false,
      //   priority: 4,
      // },
      // {
      //   id: "ideation",
      //   title: "Refine/Tweak Your Idea",
      //   description: "Discover gaps and opportunities based on realtime social media conversations",
      //   path: "/ideate",
      //   icon: <Sparkles className="w-5 h-5" />,
      //   isPro: false,
      //   priority: 3,
      // },
      // {
      //   id: "leads",
      //   title: "Find Early Users",
      //   description: "Discover potential early adopters",
      //   path: "/leadfinder",
      //   icon: <Users className="w-5 h-5" />,
      //   isPro: false,
      //   priority: 4,
      // },
    ],
  },

  {
    id: "ideating",
    title: "💡 I’m Still Looking for an Idea",
    description: "I don’t know what to build yet.",
    icon: <Lightbulb className="w-6 h-6" />,
    tasks: [
      {
        id: "ideation",
        title: "🧠 Discover Better Startup Ideas",
        description: "Tap into realtime social media conversations to find gaps in current market",
        path: "/ideate",
        icon: <Sparkles className="w-5 h-5" />,
        isPro: false,
        priority: 1,
      },

      {
        id: "business-plan",
        title: "📊 Validate with 100+ Page Report",
        description: "See market size, competitors, JTBD, pricing and more.",
        path: "/report",
        icon: <FileText className="w-5 h-5" />,
        isPro: false,
        priority: 2,
      },
      {
        id: "tiktok",
        title: "🎥 Launch with Viral TikToks & Reels",
        description: "Push unlimited Hook + Demo Videos that drive traffic.",
        path: "/video",
        icon: <Video className="w-5 h-5" />,
        isPro: false,
        priority: 3,
      },

      // {
      //   id: "leads",
      //   title: "Find Early Users",
      //   description: "Discover potential early adopters",
      //   path: "/leadfinder",
      //   icon: <Users className="w-5 h-5" />,
      //   isPro: false,
      //   priority: 4,
      // },
    ],
  },
];

export default function OnboardingChecklist({ userName = "there", onTaskClick = (path) => (window.location.href = path), onClose }) {
  const [selectedStage, setSelectedStage] = useState(() => {
    const saved = localStorage.getItem("selectedStage");
    return saved ? businessStages.find((stage) => stage.id === saved) || null : null;
  });

  const [completedTasks, setCompletedTasks] = useState(() => {
    const saved = localStorage.getItem("onboardingProgress");
    return saved ? JSON.parse(saved) : [];
  });

  const [showResetConfirm, setShowResetConfirm] = useState(false);

  useEffect(() => {
    localStorage.setItem("onboardingProgress", JSON.stringify(completedTasks));
  }, [completedTasks]);

  // const isTaskUnlocked = (priority) => {
  //   if (priority === 1) return true;
  //   const previousTask = selectedStage?.tasks.find((t) => t.priority === priority - 1);
  //   return previousTask && completedTasks.includes(previousTask.id);
  // };
  const isTaskUnlocked = (priority) => {
    // Always return true - all tasks within a selected stage are now unlocked by default.
    return true;
  };

  const handleStageSelect = (stage) => {
    setSelectedStage(stage);
    localStorage.setItem("selectedStage", stage.id);
    setShowResetConfirm(false);
  };

  const handleTaskClick = (task) => {
    if (!task.isPro && isTaskUnlocked(task.priority)) {
      onTaskClick(task.path);
    }
  };

  const toggleTaskCompletion = (e, taskId, priority) => {
    e.stopPropagation();
    if (!isTaskUnlocked(priority)) return;
    setCompletedTasks((prev) => (prev.includes(taskId) ? prev.filter((id) => id !== taskId) : [...prev, taskId]));
  };

  const resetProgress = () => {
    setCompletedTasks([]);
    setSelectedStage(null);
    localStorage.removeItem("onboardingProgress");
    localStorage.removeItem("selectedStage");
    localStorage.removeItem("hasSeenOnboarding");
    setShowResetConfirm(false);
  };

  const handleClose = () => {
    localStorage.setItem("hasSeenOnboarding", "true");
    onClose?.();
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="w-full max-w-2xl mx-auto p-2 sm:p-4"
    >
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-emerald-600 to-emerald-500 p-4 sm:p-6 text-white relative overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(255,255,255,0.1),_transparent)] opacity-70" />
          <div className="relative">
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  {selectedStage && (
                    <button onClick={() => setSelectedStage(null)} className="p-2 -ml-2 rounded-full hover:bg-white/10 transition-colors">
                      <ArrowLeft className="w-5 h-5" />
                    </button>
                  )}
                  <h2 className="text-xl sm:text-2xl font-bold">Welcome {userName}! 👋</h2>
                </div>
                <p className="text-emerald-50 text-sm sm:text-base mt-2">
                  {!selectedStage ? "Where are you in your startup journey?" : "Let’s get you started with the right tools"}
                </p>
              </div>
              <button
                onClick={handleClose}
                className="text-white/80 hover:text-white text-lg ml-2 hover:bg-white/10 p-2 rounded-full transition-all"
              >
                ✕
              </button>
            </div>

            {selectedStage && (
              <div className="mt-4 sm:mt-6">
                <div className="flex justify-between text-sm mb-2">
                  <span className="text-emerald-50">
                    {completedTasks.filter((id) => selectedStage.tasks.some((task) => task.id === id && !task.isPro)).length} of{" "}
                    {selectedStage.tasks.filter((task) => !task.isPro).length} steps completed
                  </span>
                </div>
                <div className="h-2 bg-emerald-700/30 rounded-full overflow-hidden">
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{
                      width: `${
                        (completedTasks.filter((id) => selectedStage.tasks.some((task) => task.id === id && !task.isPro)).length /
                          selectedStage.tasks.filter((task) => !task.isPro).length) *
                        100
                      }%`,
                    }}
                    className="h-full bg-white"
                    transition={{ duration: 0.5 }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="p-4 sm:p-6">
          {!selectedStage ? (
            <div className="space-y-3">
              {businessStages.map((stage) => (
                <motion.div
                  key={stage.id}
                  whileHover={{ scale: 1.01 }}
                  whileTap={{ scale: 0.99 }}
                  className="cursor-pointer group relative rounded-xl border border-gray-200 hover:border-emerald-200 hover:bg-gray-50/80 p-4 sm:p-6 transition-all duration-300"
                  onClick={() => handleStageSelect(stage)}
                >
                  <div className="flex items-center gap-4">
                    <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600">
                      {stage.icon}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-base sm:text-lg font-medium text-gray-900">{stage.title}</h3>
                      <p className="text-sm text-gray-500 mt-0.5 line-clamp-2">{stage.description}</p>
                    </div>
                    <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-emerald-500 transition-colors" />
                  </div>
                </motion.div>
              ))}
            </div>
          ) : (
            <AnimatePresence mode="wait">
              <div className="space-y-3">
                {selectedStage.tasks.map((task) => {
                  const isUnlocked = isTaskUnlocked(task.priority);
                  const isCompleted = completedTasks.includes(task.id);

                  return (
                    <motion.div
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      key={task.id}
                      className={`
                        group relative rounded-xl border 
                        ${
                          isCompleted
                            ? "border-emerald-200 bg-emerald-50/50"
                            : isUnlocked
                            ? "border-gray-200 hover:border-emerald-200 hover:bg-gray-50/80"
                            : "border-gray-200 bg-gray-50/50"
                        } 
                        p-4 sm:p-6 transition-all duration-300
                        ${!task.isPro && isUnlocked ? "cursor-pointer" : "cursor-default"}
                      `}
                      onClick={() => !task.isPro && handleTaskClick(task)}
                    >
                      {/* Priority Number */}
                      <div className="absolute -left-0.5 top-1/2 -translate-y-1/2 -translate-x-1/2">
                        <div
                          className={`
                          w-6 h-6 sm:w-8 sm:h-8 
                          flex items-center justify-center 
                          rounded-full 
                          font-semibold 
                          text-sm
                          shadow-lg
                          ring-4 ring-white
                          transition-colors
                          ${
                            isCompleted
                              ? "bg-emerald-500 text-white"
                              : isUnlocked
                              ? "bg-white text-gray-600 border border-gray-200"
                              : "bg-gray-200 text-gray-400"
                          }
                        `}
                        >
                          {task.priority}
                        </div>
                      </div>

                      <div className="flex items-start gap-3 sm:gap-4">
                        {/* Task Icon */}
                        <div
                          className={`
                          flex-shrink-0 
                          w-10 h-10 sm:w-12 sm:h-12
                          rounded-xl
                          flex items-center justify-center
                          transition-colors
                          ${
                            isCompleted
                              ? "bg-emerald-100 text-emerald-600"
                              : isUnlocked
                              ? "bg-emerald-100 text-emerald-600"
                              : "bg-gray-100 text-gray-400"
                          }
                        `}
                        >
                          {!isUnlocked ? <Lock className="w-5 h-5 sm:w-6 sm:h-6" /> : task.icon}
                        </div>

                        {/* Task Content */}
                        <div className="flex-1 min-w-0">
                          <div className="flex items-start justify-between gap-2">
                            <div>
                              <h3
                                className={`
                                text-sm sm:text-base font-semibold mb-1
                                ${isCompleted ? "text-emerald-900" : isUnlocked ? "text-gray-900" : "text-gray-400"}
                              `}
                              >
                                {task.title}
                              </h3>
                              <p
                                className={`
                                text-xs sm:text-sm leading-relaxed
                                ${isCompleted ? "text-emerald-600" : isUnlocked ? "text-gray-500" : "text-gray-400"}
                              `}
                              >
                                {task.description}
                              </p>
                            </div>

                            {/* Completion Button */}
                            {!task.isPro && (
                              <button
                                onClick={(e) => toggleTaskCompletion(e, task.id, task.priority)}
                                className={`
                                  flex-shrink-0 
                                  p-2 sm:p-2.5
                                  rounded-xl
                                  transition-all
                                  ${
                                    isCompleted
                                      ? "bg-emerald-100 text-emerald-600 hover:bg-emerald-200"
                                      : isUnlocked
                                      ? "bg-gray-100 text-gray-400 hover:bg-gray-200"
                                      : "bg-gray-100 text-gray-300 cursor-not-allowed"
                                  }
                                `}
                                disabled={!isUnlocked}
                              >
                                <Check className="w-4 h-4 sm:w-5 sm:h-5" />
                              </button>
                            )}
                          </div>

                          {/* Progress Bar */}
                          <div className="mt-3 opacity-0 group-hover:opacity-100 transition-opacity">
                            <div className="h-1 w-full bg-gray-100 rounded-full overflow-hidden">
                              <motion.div
                                initial={{ width: 0 }}
                                animate={{ width: isCompleted ? "100%" : "0%" }}
                                className="h-full bg-emerald-500"
                                transition={{ duration: 0.3 }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Left Border Accent */}
                      <div
                        className={`
                        absolute left-0 top-0 bottom-0 w-1 
                        rounded-l-xl
                        transition-colors
                        ${isCompleted ? "bg-emerald-500" : "bg-transparent group-hover:bg-emerald-500"}
                      `}
                      />

                      {/* Locked Overlay */}
                      {!isUnlocked && (
                        <div className="absolute inset-0 bg-white/50 backdrop-blur-[1px] flex items-center justify-center rounded-xl">
                          <span className="text-xs sm:text-sm font-medium text-gray-600 bg-white/80 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full shadow-sm">
                            {/* Complete previous step first */}
                            Mark First as Complete
                          </span>
                        </div>
                      )}
                    </motion.div>
                  );
                })}
              </div>
            </AnimatePresence>
          )}

          {/* Footer Actions */}
          <div className="mt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
            {showResetConfirm ? (
              <div className="flex items-center gap-2 w-full sm:w-auto">
                <button
                  onClick={resetProgress}
                  className="flex-1 sm:flex-none px-4 py-2 text-sm text-white bg-red-500 hover:bg-red-600 rounded-lg transition-colors"
                >
                  Yes, reset everything
                </button>
                <button
                  onClick={() => setShowResetConfirm(false)}
                  className="flex-1 sm:flex-none px-4 py-2 text-sm text-gray-600 hover:text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  Cancel
                </button>
              </div>
            ) : (
              <div className="flex w-full sm:w-auto">
                {selectedStage ? (
                  <button
                    onClick={() => setSelectedStage(null)}
                    className="flex-1 sm:flex-none flex items-center justify-center gap-2 text-sm text-gray-600 hover:text-gray-800 px-4 py-2 hover:bg-gray-100 rounded-lg transition-colors"
                  >
                    <ArrowLeft className="w-4 h-4" />
                    Change Stage
                  </button>
                ) : (
                  <button
                    onClick={() => setShowResetConfirm(true)}
                    className="flex-1 sm:flex-none flex items-center justify-center gap-2 text-sm text-gray-600 hover:text-gray-800 px-4 py-2 hover:bg-gray-100 rounded-lg transition-colors"
                  >
                    <RefreshCw className="w-4 h-4" />
                    Reset Progress
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
